// Página não encontrada (defaultNotFoundComponent do router). Antes caía no
// "Not Found" cru do TanStack Router, sem saída — foi o que o link de convite e
// o retorno do Stripe mostravam quando a rota não existia.
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { Button } from "@organizacaox/lai-design-system";
import { NotFoundIllustration } from "./components/not-found-illustration";

export function NotFoundScreen() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background px-6 py-16 text-center">
      <NotFoundIllustration className="mb-8 max-w-[260px]" />
      <h1 className="text-2xl font-semibold tracking-tight text-balance">{t("notFound.title")}</h1>
      <p className="mt-2 mb-8 max-w-sm text-sm text-muted-foreground text-balance">
        {t("notFound.body")}
      </p>
      <Button nativeButton={false} role="link" render={<Link to="/" />}>
        {t("notFound.home")}
      </Button>
    </main>
  );
}
